import ng from 'angular';
import { SystemHelperService } from '@/services';

export class TemplateAccountActivationBasicDataController {
    public static $inject: string[] = [
        'systemHelper'
    ]

    public city: string;
    public country: string;
    public email: string;
    public formIsValid: boolean;
    public name: string;
    public panelRightSettings = { editPanelButton: true }
    public password: string;
    public repeatPassword: string;
    public phone: string;
    public saveCallback: () => Promise<void>;
    public street: string;
    public zipCode: string;

    constructor(
        private systemHelper: SystemHelperService
    ) {}

    public get countryName(): string {
        return this.systemHelper.getReadableCountry(this.country);
    }
}

export class TemplateAccountActivationBasicDataComponent implements ng.IComponentOptions {
    public bindings = {
        city: '=',
        country: '<',
        email: '<',
        formIsValid: '=',
        name: '<',
        password: '=',
        phone: '=',
        saveCallback: '<',
        street: '=',
        token: '<',
        zipCode: '=',
    };
    public template = require('./basic-data.html');
    public controller = TemplateAccountActivationBasicDataController;
}